module.exports = __webpack_public_path__ + "img/Carte-platinum-blanche.62f217ef.png";